import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import { errorMessage, post } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export const SupportViewBanner = ({ view }) => {
  const { refreshProfile } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const ends = new Date(view.expires_at);

  useEffect(() => {
    const t = setTimeout(async () => {
      await refreshProfile();
      toast.info("Your support view has ended");
      navigate("/manager/companies");
    }, Math.max(ends.getTime() - Date.now(), 0) + 1000);
    return () => {
      clearTimeout(t);
    };
  }, [view.session_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const exit = async () => {
    setBusy(true);
    try {
      await post("/platform/support-view/exit");
      await refreshProfile();
      navigate("/manager/companies");
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sticky top-14 z-20 lg:top-0 flex flex-wrap items-center justify-between gap-2 bg-amber-400 px-4 py-2 text-sm font-medium text-amber-950 lg:px-8" data-testid="support-view-banner">
      <span className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        Viewing <strong data-testid="support-view-company">{view.company_name}</strong> as their manager. Changes you make are saved under your name. Ends at {ends.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}.
      </span>
      <Button size="sm" onClick={exit} disabled={busy} className="h-8 bg-amber-950 text-amber-50 hover:bg-amber-900" data-testid="support-view-exit-button">
        {busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <LogOut className="mr-1 h-4 w-4" />}Exit
      </Button>
    </div>
  );
};
